import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { EMPTY_VALUE } from '../../../constants/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const getDisplayPercentage = value => {
  if (typeof value === 'undefined' || value === null) {
    return EMPTY_VALUE;
  }
  if (value >= 100) {
    return /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedPercentage, {
        value: value
      })
    });
  }
  return /*#__PURE__*/_jsx(FormattedPercentage, {
    value: value
  });
};